import { useEffect } from "react";

/** Opens the recruit referenced by `?lead=<id>` (set by a notification click) once leads are loaded. */
export function useLeadDeepLink(leads, open) {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const id = params.get("lead");
    if (!id || !leads.length) return;
    if (leads.some((l) => l.id === id)) open(id);
    params.delete("lead");
    const qs = params.toString();
    window.history.replaceState({}, "", window.location.pathname + (qs ? `?${qs}` : ""));
  }, [leads, open]);
}
